import React from "react";
import {Icon, TextField} from "peggirkit";
import IconAddOn from "peggirkit/dist/components/Input/Field/TextField/TextFieldAddOn/IconAddOn";
import {MagnifyingGlassIcon, XMarkIcon} from "@heroicons/react/20/solid";
import ButtonAddOn from "peggirkit/dist/components/Input/Field/TextField/TextFieldAddOn/ButtonAddOn";
import {SetStateFn} from "@/utils/SetStateUtils";
import {useIntl} from "react-intl";

type Props = {
    searchQuery: string,
    setSearchQuery: SetStateFn<string>,
};

const SearchInput = ({searchQuery, setSearchQuery}: Props) => {
    const intl = useIntl();

    return (
        <TextField
            type={"text"}
            autoComplete={"off"}
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            placeholder={intl.formatMessage({id: "search-orders-placeholder"})}
            leading={IconAddOn({
                icon: <Icon icon={MagnifyingGlassIcon}/>,
                hideBorder: true,
                paddingRight: 0,
            })}
            trailing={searchQuery === "" ? undefined : ButtonAddOn({
                buttonProps: {
                    iconBefore: <Icon icon={XMarkIcon}/>,
                    iconOnly: true,
                    color: "danger",
                    variant: "text",
                    children: intl.formatMessage({id: "remove-search"}),
                    buttonAction: {
                        as: "button",
                        actionProps: {
                            onClick: () => setSearchQuery("")
                        },
                    },
                },
                position: "trailing",
            })}
        />
    );
};

export default SearchInput;